// src/auth/CheckYourEmailPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../layout/PublicHeader';
import PublicFooter from '../layout/PublicFooter';

export default function CheckYourEmailPage() {
  return (
    <div>
      <PublicHeader />

      <div className="form-container" style={{ maxWidth: 520 }}>
        <h2>Check your email</h2>

        <p>
          We’ve sent you a verification email.
        </p>

        <p>
          Please click the link in that email to verify your EveryID account.
        </p>

        <p style={{ marginTop: 16 }}>
          Once verified, you can sign in and continue to EveryID.
        </p>

        <div style={{ marginTop: 24 }}>
          <Link to="/login" className="btn">
            Go to Login
          </Link>
        </div>

        <div style={{ marginTop: 16, fontSize: 13, color: '#666' }}>
          Didn’t receive the email? Check your spam folder.
        </div>
      </div>

      <PublicFooter />
    </div>
  );
}
